module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/127.702a26d9.png";